// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"377":"chat","545":"language","822":"disclaimer"}[chunkId] + "." + {"377":"89b25fef","545":"652dca08","822":"a990682f"}[chunkId] + ".js";
};